import React from "react";

import Button from "components/ui/button/Button";

import css from "./FilterFormTitle.module.scss";

export interface FilterFormTitleProps {
  onClose: () => void;
  clearFilters?: () => void;
  showClear?: boolean;
  isSidebar?: boolean;
  isLoadingResults?: boolean;
  totalResults?: number;
}

function FilterFormTitle({
  clearFilters,
  onClose,
  showClear,
  isSidebar,
  isLoadingResults,
  totalResults,
}: FilterFormTitleProps) {
  return (
    <div className={css.wrapper}>
      <div className={css.titleContainer}>
        {isSidebar ? (
          <span>
            {isLoadingResults
              ? "Loading"
              : `${totalResults} ${totalResults === 1 ? "result" : "results"}`}
          </span>
        ) : (
          <>
            <Button
              buttonType="secondary"
              icon="chevronRightDouble"
              className={css.icon}
              onClick={() => onClose()}
              aria-label="Close filters"
            />
            <h3 className={css.title}>Filters</h3>
          </>
        )}
      </div>
      <div className={css.buttonWrapper}>
        {showClear && clearFilters && (
          <Button buttonType="tertiary" onClick={() => clearFilters()}>
            Clear all
          </Button>
        )}
      </div>
    </div>
  );
}

export default FilterFormTitle;
